export { EBWordmark } from './EBWordmark';
